<template>
  <!-- https://michalsnik.github.io/aos/ -->
  <v-container>

        <v-card
      class="mx-auto"
      max-width="550"
    >

     <v-system-bar    color="pink darken-2" dark v-show="$route.path==='/home' || $route.path==='/sets' ? true : false"></v-system-bar>

    <v-app-bar color="#424242" dark dense
      v-show="$route.path==='/home' || $route.path==='/sets' ? true : false">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>

      <!-- v-img max-height="40" max-width="40" src="/favicon.ico">
      </v-img -->

      Microcise

      </v-toolbar-title>
    </v-app-bar>

      <v-expand-transition>
      <v-card  color="grey darken-1"  dark  height="90">
        
        <v-row  dense>  
          <v-col  cols="12" class="ma-0 pa-0" >
                              <v-spacer></v-spacer>
               <v-card-text>
                <p class="ma-0 pa-0 text-h5 text-center" >Help and Support</p>      
              </v-card-text>
          </v-col>
        </v-row>

        </v-card>    
      </v-expand-transition>

      <v-card  color="grey lighten-5"  dark>



     

     





    </v-card>    

  </v-card>






<v-navigation-drawer class="grey lighten-4"
  v-model="drawer"
  absolute
  bottom
  temporary>
  <v-list nav dense>
    <v-list-item-group
      v-model="group"
      active-class="deep-purple--text text--accent-4"
    >
      <v-list-item @click.stop="$router.push('/sets')">
        <v-list-item-icon>
          <v-icon>list</v-icon>
          <span>Sets</span>
        </v-list-item-icon>    
      </v-list-item>

      <v-list-item @click.stop="$router.push('/activity')">
        <v-list-item-icon>
          <v-icon>schedule</v-icon>
          <span>Activity</span>
        </v-list-item-icon>   
      </v-list-item>

    <div v-if="signedIn">
      <v-list-item @click="logout()">
        <v-list-item-icon>
          <v-icon>logout</v-icon>
          <span>Sign Out</span>
        </v-list-item-icon>   
      </v-list-item>
      </div>


    </v-list-item-group>
  </v-list>
</v-navigation-drawer>
  </v-container>
</template>

<style>
.v-progress-circular {
margin: 1rem;
}
</style>



<script>
export default {

  data: () => ({

  }),
  
         
}
</script>


<style>
.max-width-chip.v-chip {
  max-width: 70px;
  min-width: 70px;
}


.max-width-chip .v-chip__content {
  line-height: 32px;
  display: inline-block !important;
  white-space: nowrap;
  overflow: hidden;
   text-overflow: ellipsis;
  position: relative;
}

</style>
